import en from './en.json';
import { flattenObject } from '../lib/flattenObject';

export const code = 'en';
export const stringLocale = flattenObject(en) as Record<string, string>;
export const dateLocale = null;
